import React from "react"

import ControlButtonMenu from "../../popover-menu/popup-menu-button/control-button-with-menu"
import { CoverPosition} from "../../../model2/task/properties/cover"
import CoverPositionMenu from "./more-menu"

type Props = {
    className?          : string

    value               : CoverPosition

    onSelect?           : {(value: CoverPosition): void}
    onTogglePopover?    : {(value: boolean): void}
}

const debug = false
// const debug = "CoverPositionSelector"

export default function CoverPositionSelector(props: Props) {

    debug && console.log(debug, 'render', props)

    return (
        <ControlButtonMenu className            = {props.className}
                           menuComponent        = {CoverPositionMenu}
                           offset               = "0 -8"
                           hint                 = "Select position"
                           menuParams           = {{
                               position             : props.value,
                               onPositionSelected   : props.onSelect
                           }}
                           clickOutsideDelay    = {0}
                           onTogglePopover      = {props.onTogglePopover}>
            <div className="ui5-txt-not-important m-l-10 m-r-10">Position</div>
        </ControlButtonMenu>
    )
}